<div class="wrapper">
  <app-header />
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <app-footer />
</div>
